module.exports = __webpack_public_path__ + "static/media/Mshaikh.602b3933.png";